import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import CloudIcon from '../../../assets/images/cloud-on.svg';
import MusicIcon from '../../../assets/images/music-on.svg';

export const WelcomeStep = () => {
  const [isMobile, setIsMobile] = useState(() => {
    // Inicializar con detección inmediata de mobile si window existe
    if (typeof window !== 'undefined') {
      return window.innerWidth <= 768;
    }
    return false;
  });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const versions = [
    { name: 'versión-3.mp3', opacity: 1 },
    { name: 'versión-2.mp3', opacity: 0.6 },
    { name: 'versión-1.mp3', opacity: 0.3 }
  ];

  // Mobile: Solo contenido animado centrado
  if (isMobile) {
    return (
      <div className="flex flex-col justify-center items-center">
        {/* Icono de la nube */}
        <motion.img
          src={CloudIcon}
          alt="Cloud icon"
          className="w-[88px] h-[88px] mb-4"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ 
            duration: 0.6,
            delay: 0.3,
            ease: "easeOut"
          }}
        />
        
        {/* Flecha hacia arriba y línea vertical */}
        <motion.div
          className="flex flex-col items-center"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 0.4,
            delay: 0.9,
            ease: "easeOut"
          }}
        >
          {/* Punta de flecha hacia arriba */}
          <div
            className="w-0 h-0 border-l-[6px] border-r-[6px] border-b-[8px] border-l-transparent border-r-transparent"
            style={{
              borderBottomColor: '#FFB447'
            }}
          />
          {/* Línea vertical */}
          <div 
            className="w-[2px] bg-[#FFB447]"
            style={{ height: '30px' }}
          />
        </motion.div>
        
        {/* Recuadro con versiones */}
        <motion.div
          className="relative w-[100%]"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ 
            duration: 0.5,
            delay: 1.2,
            ease: "easeOut"
          }}
        >
          {/* Contenedor con gradiente de borde */}
          <div 
            className="rounded-t-[8px] overflow-hidden"
            style={{
              background: 'linear-gradient(to bottom, #FFB447 0%, #B296FF 100%)',
              paddingTop: '1px',
              paddingLeft: '1px',
              paddingRight: '1px',
              paddingBottom: '0px'
            }}
          >
            {/* Contenido interior */}
            <div 
              className="rounded-t-[8px] py-2 px-2 bg-black flex flex-col items-center"
              style={{ borderBottom: 'none' }}
            >
              {versions.map((version, index) => (
                <motion.div
                  key={version.name}
                  className="flex items-center gap-3 mb-1 last:mb-0 justify-center"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: version.opacity, y: 0 }}
                  transition={{ 
                    duration: 0.4,
                    delay: 1.5 + (index * 0.2),
                    ease: "easeOut"
                  }}
                  style={{ opacity: version.opacity }}
                >
                  <img 
                    src={MusicIcon} 
                    alt="Music icon" 
                    className="w-[45px] h-[53px]"
                  />
                  <span 
                    className="text-[24px] font-archivo text-white"
                  >
                    {version.name}
                  </span>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    );
  }

  // Desktop: Layout 50/50
  return (
    <div className="flex-1 flex px-2">
      {/* Texto del lado izquierdo - 50% */}
      <div className="w-1/2 flex items-center">
        <h1 className="text-white !font-[500] text-[34px] leading-[38px] !font-archivo normal-case">
          Guardá todas tus maquetas en un mismo lugar
        </h1>
      </div>
      
      {/* Contenedor derecho con animaciones - 50% */}
      <div className="w-1/2 flex flex-col justify-center items-center relative pl-2">
        {/* Icono de la nube */}
        <motion.img
          src={CloudIcon}
          alt="Cloud icon"
          className="w-[65px] h-[65px] mb-2"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ 
            duration: 0.6,
            delay: 0.3,
            ease: "easeOut"
          }}
        />
        
        {/* Flecha hacia arriba y línea vertical */}
        <motion.div
          className="flex flex-col items-center"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 0.4,
            delay: 0.9,
            ease: "easeOut"
          }}
        >
          {/* Punta de flecha hacia arriba */}
          <div
            className="w-0 h-0 border-l-[6px] border-r-[6px] border-b-[8px] border-l-transparent border-r-transparent"
            style={{
              borderBottomColor: '#FFB447'
            }}
          />
          {/* Línea vertical */}
          <div 
            className="w-[2px] bg-[#FFB447]"
            style={{ height: '30px' }}
          />
        </motion.div>
        
        {/* Recuadro con versiones */}
        <motion.div
          className="relative"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ 
            duration: 0.5,
            delay: 1.2,
            ease: "easeOut"
          }}
        >
          {/* Contenedor con gradiente de borde */}
          <div 
            className="rounded-t-[5px]"
            style={{
              background: 'linear-gradient(to bottom, #FFB447 0%, #B296FF 100%)',
              padding: '1.40px',
              borderBottom: 'none',
              paddingBottom: '0px'
            }}
          >
            {/* Contenido interior */}
            <div 
              className="rounded-t-[5px] p-3 bg-black"
            >
              {versions.map((version, index) => (
                <motion.div
                  key={version.name}
                  className="flex items-center gap-2 mb-2 last:mb-0"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: version.opacity, y: 0 }}
                  transition={{ 
                    duration: 0.4,
                    delay: 1.5 + (index * 0.2),
                    ease: "easeOut"
                  }}
                  style={{ opacity: version.opacity }}
                >
                  <img 
                    src={MusicIcon} 
                    alt="Music icon" 
                    className="w-[29px] h-[34px]"
                  />
                  <span 
                    className="text-[20px] font-archivo text-white"
                  >
                    {version.name}
                  </span>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};